import { Module } from 'vuex'
import { RootState } from '@/store/store-types'
import { useAppContentHttp } from '@/core/api/app-contents'
import { AppContent, AppContentPayload } from '@/core/models/app-content'

const state: AppContent = new AppContent(<AppContentPayload>{})

export const appContent: Module<AppContent, RootState> = {
    namespaced: true,
    state,
    mutations: {
        update: (state: AppContent, payload: AppContentPayload) => {
            state.fill(payload)
        }
    },
    actions: {
        patch: <T>(context: any, payload: { payload: any }): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useAppContentHttp()
                    .patch(payload.payload)
                    .then((data: any) => {
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        },
    },
    getters: {
        get: (state: AppContent): AppContent => {
            return state
        }
    }
}
